import React from 'react';

const About: React.FC = () => {
    const features = [
        { icon: "/icons/upload.svg", title: "Upload", description: "Upload your resume or job description." },
        { icon: "/icons/match.svg", title: "Match", description: "David refines the search and finds potential fits." },
        { icon: "/icons/connect.svg", title: "Connect", description: "Mutual interest? A direct chat is created." },
        { icon: "/icons/manage.svg", title: "Manage", description: "Scheduling and pipeline handled automatically." }
    ];

    return (
        <section className="relative pt-2 pb-4 px-[22px] sm:px-4 overflow-x-hidden">
            <div className="container mx-auto max-w-[1600px] relative z-10 sm:px-16">
                {/* Title and Subtitle Section - Figma Mobile Spec */}
                <div className="mb-[40px] sm:mb-20">
                    {/* Title - Figma Mobile spec: 24px */}
                    <h2
                        className="text-white mb-4 sm:mb-8 sm:!text-[clamp(48px,6vw,96px)] sm:!leading-[clamp(56px,7vw,110px)]"
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 700,
                            fontSize: '24px',
                            lineHeight: '33px',
                            letterSpacing: '-0.05em'
                        }}
                    >
                        Meet David, your AI recruiter
                    </h2>

                    {/* Subtitle - Figma Mobile spec: 13px */}
                    <div className="sm:ml-[20%]">
                        <p
                            className="text-white sm:!text-[clamp(16px,2vw,32px)] sm:!leading-[clamp(24px,2.5vw,44px)]"
                            style={{
                                fontFamily: 'Manrope',
                                fontWeight: 200,
                                fontSize: '13px',
                                lineHeight: '18px',
                                letterSpacing: '-0.05em',
                                textAlign: 'left'
                            }}
                        >
                            David, Hush's AI recruiter, connects companies with top passive talent by handling matching, outreach, introductions, and scheduling — ensuring candidates find the right roles and employers meet only qualified, interested people.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mb-[64px] sm:mb-32">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="transition-all duration-300 hover:scale-[1.02] p-3 sm:p-6 gap-2 sm:gap-4 min-h-[180px] sm:min-h-[240px]"
                            style={{
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                width: '100%',
                                background: 'rgba(20, 30, 48, 0.4)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: '16px'
                            }}
                        >
                            <img
                                src={feature.icon}
                                alt={feature.title}
                                className="w-[50px] h-[50px] sm:w-[80px] sm:h-[80px]"
                                style={{
                                    objectFit: 'contain',
                                    filter: 'brightness(1.1)',
                                    flex: 'none'
                                }}
                            />
                            <h3
                                className="text-[16px] sm:text-[20px] leading-[20px] sm:leading-[28px]"
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 600,
                                    letterSpacing: '-0.01em',
                                    color: '#FFFFFF',
                                    margin: 0,
                                    textAlign: 'center'
                                }}
                            >
                                {feature.title}
                            </h3>
                            <p
                                className="text-[11px] sm:text-[14px] leading-[16px] sm:leading-[20px] px-1 sm:px-0"
                                style={{
                                    fontFamily: 'Manrope',
                                    fontWeight: 400,
                                    letterSpacing: '0em',
                                    textAlign: 'center',
                                    color: 'rgba(255, 255, 255, 0.75)',
                                    margin: 0
                                }}
                            >
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Title and Subtitle Section - Figma Mobile Spec */}
                <div className="mb-0">
                    {/* Title - Figma Mobile spec: 32px, multi-line */}
                    <h2
                        className="text-white mb-4 w-[358px] max-w-full sm:w-auto sm:mb-8 sm:!text-[clamp(48px,6vw,96px)] sm:!leading-[clamp(56px,7vw,110px)] sm:max-w-[60%]"
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 700,
                            fontSize: '32px',
                            lineHeight: '34px',
                            letterSpacing: '-0.05em'
                        }}
                    >
                        The best talent isn't actively looking
                    </h2>

                    {/* Subtitle - Figma Mobile spec: 13px */}
                    <div className="sm:ml-[35%]">
                        <p
                            className="text-white w-[345px] max-w-full sm:w-auto sm:!text-[clamp(16px,2vw,32px)] sm:!leading-[clamp(24px,2.5vw,44px)]"
                            style={{
                                fontFamily: 'Manrope',
                                fontWeight: 200,
                                fontSize: '13px',
                                lineHeight: '18px',
                                letterSpacing: '-0.05em',
                                textAlign: 'justify'
                            }}
                        >
                            70% of the global workforce is made up of passive candidates — people not actively applying for jobs, but open to the right opportunity. Traditional recruiting methods miss out on this hidden talent, and external headhunters deliver less than a 2% placement ratio.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
